import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditActionComponent } from './edit-action/edit-action.component';

const routes: Routes = [
  {
    path: ':action/:action_id',
    component: EditActionComponent,
  },
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '/orders', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ActionsRoutingModule {}
